




























import { computed, defineComponent, getCurrentInstance } from '@vue/composition-api';
import BaseIcon from '@/renderer/components/common/BaseIcon.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import collectSuccess from '@/renderer/assets/images/Icon/svg/successPay.svg';
import { copyText2Clipboard } from '@/renderer/scripts/utils/tools';
import tips from '@/renderer/scripts/utils/tips';
import { httpUrl } from '@/renderer/scripts/http';
import store from '@/renderer/store';
export default defineComponent({
  name: 'FileCollectResult',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    domain: {
      type: String,
      required: true,
      default: '',
    },
    code: {
      type: String,
      default: '',
    },
    joinType: {
      type: Number,
      default: 0,
    },
  },
  components: {
    BaseIcon,
  },
  setup(props, context) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const shareTitle = computed(() => {
      return i18n_t('{slot1}邀请您参与文件收集任务，点击链接开始提交你的文件吧。', {
        slot1: store.getters.userBaseInfo.nickname,
      });
    });
    const inviteUrl = computed(() => {
      const url = i18n_t('链接：{slot1}/web/collect/{slot2}', {
        slot1: props.domain,
        slot2: encodeURIComponent(props.code),
      });
      return url;
    });
    const showLink = computed(() => {
      return props.joinType === 1;
    });
    const methods = {
      copyLink(link: string) {
        copyText2Clipboard(link)
          .then(() => {
            tips.success(i18n_t('分享链接已复制到剪贴板'));
          })
          .catch(() => {
            tips.error(i18n_t('分享链接复制出错'));
          });
      },
    };
    return {
      ...methods,
      inviteUrl,
      innerShow,
      showLink,
      shareTitle,
      collectSuccess,
    };
  },
});
